import { Form, Input, Modal } from "antd";
import React, { useState } from "react";
import ReactQuill from "react-quill";
import { useSelector } from "react-redux";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IGeneralState } from "types";

export const AddTopicModal: React.FC<any> = ({ ...props }) => {
	const { id: userId } = useSelector((state: IGeneralState) => state.app.user);
	const { form, isOpen, setIsOpen, forumId, setForumTopics } = props;

	const [topicContent, setTopicContent] = useState<string>(
		"Digite aqui sua mensagem."
	);

	const handleSendMessage = async (topicId: string) => {
		await api
			.post(`/topics/${topicId}/messages`, {
				id_topico: topicId,
				text: topicContent,
				user_id: userId,
				is_active: true,
			})
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					console.log(feedback);
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	const handleRegister = (values: any) => {
		api
			.post(`/forums/${forumId}/topics`, values)
			.then(async (result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;

					await api.get(`/forums/${forumId}/topics`).then(async (res) => {
						const lastCreatedTopicId =
							res.data.data.topics[res.data.data.topics.length - 1]?.id;
						await handleSendMessage(lastCreatedTopicId);
					});

					api.get(`/forums/${forumId}/topics`).then((res) => {
						setForumTopics(res.data.data.topics);
					});
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Cadastrar novo tópico</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar tópico"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = {
							...values,
							id_forum: forumId,
							is_active: true,
							status: "open",
							created_by: userId,
						};
						handleRegister(allValues);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				form.resetFields();
			}}
			className="modal-users"
		>
			<Form form={form} name="new-user" autoComplete="off">
				<div className="users-modal" style={{ width: "100%" }}>
					<div className="users-modal__login-info" style={{ width: "100%" }}>
						<div className="users-modal__login-info__topicInputs">
							<Form.Item
								name="subject"
								rules={[
									{
										required: true,
										message: "Assunto necessário",
									},
								]}
							>
								<Input placeholder="Assunto do tópico" />
							</Form.Item>
							<div
								className="users-modal__login-info__topic"
								style={{ marginTop: "5px" }}
							>
								<ReactQuill
									theme="snow"
									value={topicContent}
									onChange={setTopicContent}
								/>
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
